<template>
  <div>
    <ViewIMC title="IMC" :resident_id="resident_id" />
  </div>
</template>

<script>
import routes from "../../../routes";

import ViewIMC from "../../IMC/View";

export default {
  name: "IMC",

  components: {
    ViewIMC,
  },

  data() {
    return {
      resident_id: "",
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    retrieve() {
      const { id } = routes.history.current.params;
      this.resident_id = id;
    },
  },
};
</script>